import React, { FC } from 'react';
import { Box, useTheme } from '@mui/material';
import { isToday } from 'date-fns';

import { formatUTCDate } from '../../utils';
import { Typography } from '../Typography/Typography';
import { Icon } from '../Icon/Icon';

export interface DeliveryUpdateInfoProps {
  updatedAt: string;
  updatedByName: string;
  currentUserId?: string;
  updatedById: string;
}

export const DeliveryUpdateInfo: FC<DeliveryUpdateInfoProps> = ({
  updatedAt,
  updatedByName,
  currentUserId,
  updatedById,
}) => {
  const theme = useTheme();

  const isUpdatedToday = isToday(new Date(updatedAt));

  const formattedDate = formatUTCDate(updatedAt, 'longMonthDayYear');

  const displayName = currentUserId === updatedById ? 'You' : updatedByName;

  const updateMessage = isUpdatedToday
    ? `Last modified Today by ${displayName}`
    : `Last modified on ${formattedDate} by ${displayName}`;

  const editIcon = (
    <Icon
      name="edit-outline"
      size="medium"
      fill={theme.palette.secondary.dark}
    />
  );

  return (
    <Box display="flex" flexDirection="row" alignItems="center" marginTop={0.5}>
      {editIcon}
      <Typography
        variant="subtitle2"
        color={theme.palette.text.secondary}
        marginLeft={0.5}
        fontWeight={400}
        fontSize={13}
      >
        {updateMessage}
      </Typography>
    </Box>
  );
};

export default DeliveryUpdateInfo;
